import React, { useEffect, useState } from 'react'
import ErrorIcon from '../resources/img/svg/ErrorIcon.svg'
import SuccessIcon from '../resources/img/svg/SuccessIcon.svg'
import { Box, Card, Slide, Snackbar, Typography } from '@mui/material'
import { useDispatch } from 'react-redux'
import { updateShowToast } from '../utils/toastSlice'

const Toast = ({ status, message, title, setViewToast }) => {
	const [open, setOpen] = useState(true)
	const dispatch = useDispatch()

	const handleClose = (reason) => {
		if (reason === 'clickaway') {
			return
		}
		setOpen(false)
	}

	useEffect(() => {
		const timer = setInterval(() => {
			dispatch(updateShowToast(false))
		}, 3000)

		return () => clearInterval(timer)
	}, [])

	const icon = status === 0 ? ErrorIcon : SuccessIcon
	const titleColor = status === 0 ? '#FD003D' : '#33E37A'

	return (
		<Snackbar
			open={open}
			anchorOrigin={{ vertical: 'top', horizontal: 'center' }} // Changed to top center
			autoHideDuration={6000}
			onClose={(event, reason) => handleClose(reason)}
			TransitionComponent={Slide}
			sx={{
				zIndex: 99999,
				top: '90px !important', // Add some top spacing
				left: '50% !important',
				right: 'auto !important',
				transform: 'translateX(-50%) !important', // Ensure perfect centering
			}}
		>
			<Card
				sx={{
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'space-between',
					alignItems: 'center',
					maxWidth: '450px',
					minWidth: '450px',
					borderRadius: '10px',
					padding: '15px',
					backgroundColor: 'common.white',
					boxShadow: (theme) => theme.shadows[5],
					'@media (max-width: 600px)': {
						// Make responsive for mobile
						maxWidth: '90vw',
						minWidth: '90vw',
						margin: '0 auto',
					},
				}}
			>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'space-between',
						alignItems: 'center',
						gap: '20px',
						width: '100%',
					}}
				>
					<Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px', flexGrow: 1 }}>
						<div style={{ paddingRight: '10px' }}>
							<img src={icon} alt={status === 0 ? 'Error Icon' : 'Success Icon'} />
						</div>

						<Box
							sx={{
								display: 'flex',
								flexDirection: 'column',
								width: '100%',
							}}
						>
							<Typography
								variant='h6'
								sx={{
									display: '-webkit-box',
									overflow: 'hidden',
									WebkitBoxOrient: 'vertical',
									WebkitLineClamp: 1,
									wordBreak: 'break-word',
									color: titleColor,
									'@media (max-width: 600px)': {
										fontSize: '16px',
									},
								}}
							>
								{title ? title : status === 0 ? 'Error' : 'Success'}
							</Typography>

							{message && (
								<Typography
									variant='h6'
									sx={{
										display: '-webkit-box',
										overflow: 'hidden',
										WebkitBoxOrient: 'vertical',
										WebkitLineClamp: 4,
										wordBreak: 'break-word',
										color: 'text.tertiary',
										'@media (max-width: 600px)': {
											fontSize: '16px',
										},
									}}
								>
									{message}
								</Typography>
							)}
						</Box>
					</Box>
				</Box>
			</Card>
		</Snackbar>
	)
}

export default Toast
